import $ from "jquery";
import {
  getVh,
  getWindowWidth,
  getScrollBarWidth,
  debounce,
  isVerticalOverflown,
} from "./functions";

const $window = $(window);
const $root = $(":root");

injectProps();
bindInject();

function bindInject() {
  $window.on("resize:width", injectWindowProps);
  $window.on("resize:height", injectSizeProps);
  $window.on(
    "resize",
    debounce(function () {
      injectScrollBarProps();
    })
  );
  $window.on(
    "reactRender:done",
    debounce(function () {
      injectScrollBarProps();
    })
  );
}

function injectProps() {
  injectSizeProps();
  injectWindowProps();
  injectScrollBarProps();
}

function injectSizeProps() {
  $root.css("--vh", getVh() + "px");
}
function injectWindowProps() {
  $root.css("--window-width", getWindowWidth() + "px");
}
function injectScrollBarProps() {
  $root.css(
    "--scrollbar-width",
    (isVerticalOverflown(document.querySelector(".page__body"))
      ? getScrollBarWidth()
      : 0) + "px"
  );
}
